export enum EOrderDeliveryExpeditionType {
  Pickup = 'pickup',
  DropOff = 'drop_off'
}

export const orderDeliveryExpeditionTypeVerbs = {
  [EOrderDeliveryExpeditionType.Pickup]: 'Coleta',
  [EOrderDeliveryExpeditionType.DropOff]: 'Despachar'
}